var lists_default = {
  "fontElementMap": "l-2VW",
  "orderedlist": "pOAjY",
  "bulletedlist": "_6Dx0q",
  "listItem": "zgTrn"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
